import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'app-config';
import { HttpClient } from '@angular/common/http';
import {
  AlertService,
  IsLoadingService,
  SignerService,
  SupportRequestDto,
} from 'common';
import { lastValueFrom } from 'rxjs';
import { EnzymeRepository, RebalancingRepository } from '../repository';
import { SupportContactData } from '../component';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  constructor(
    @Inject(APP_CONFIG) private appConfig: any,
    private readonly httpClient: HttpClient,
    private readonly signerService: SignerService,
    private readonly enzymeRepository: EnzymeRepository,
    private readonly rebalancingRepository: RebalancingRepository,
    private readonly isLoadingService: IsLoadingService,
    private readonly alertService: AlertService,
  ) {}

  public getBaseUrl(): string {
    return `${this.appConfig.tradingApiBaseUrl}/support`;
  }

  public async sendSupportRequest(
    request: SupportContactData,
  ): Promise<boolean> {
    try {
      await this.isLoadingService.add(
        lastValueFrom(
          this.httpClient.post(`${this.getBaseUrl()}`, {
            signer: this.signerService.getSigner()?.address,
            vault:
              this.enzymeRepository.store.getValue().selectedVault?.address,
            name: request.name,
            email: request.email,
            tgHandle: request.tgHandle,
            info: request.info,
            rebalancingQueryId:
              this.rebalancingRepository.store.getValue()
                .calculatingRebalancingId,
          } as SupportRequestDto),
        ),
        { key: 'support-request' },
      );
      return true;
    } catch (error: any) {
      this.alertService.showError('support.error.request');
      return false;
    }
  }
}
